import { maxLength } from "vuelidate/lib/validators";

export const actieMixin = {

    methods: {
        getBeginCyclus(actie) {
            // het laatste index jaar
            return actie.jaren.length > 0 ? actie.jaren[actie.jaren.length-1].jaar : actie.jaar || this.jaar;
        },
         // het jaar volgens de normale cyclus
         getJaarN(index,actie) {
            // het jaar volgens de normale cyclus
            if (index == 0) return actie.jaar || this.jaar;
            return actie.jaren[index-1].jaar;
        },
        getJaren(start, cyclus) {
            var c = cyclus || 1;
            var jaren = [];
            var j = start;
            while (jaren.length < 8) {
                
                jaren.push((j += c));
            }
            return jaren;
          }
       
    }
}